export function longpress(node, threshold = 500) {
  const down = (touchevent = false) => {
    const timeout = setTimeout(() => {
      node.dispatchEvent(new CustomEvent("longpress"));
      node.removeEventListener("mouseup", up);
      node.removeEventListener("touchend", up);
      node.removeEventListener("mousemove", cancel);
      node.removeEventListener("touchcancel", cancel);
    }, threshold);

    const up = (e) => {
      clearTimeout(timeout);
      node.dispatchEvent(new CustomEvent("shortpress"));
      node.removeEventListener("mouseup", up);
      node.removeEventListener("touchend", up);
      node.removeEventListener("mousemove", cancel);
      node.removeEventListener("touchcancel", cancel);
    };
    const cancel = (e) => {
      clearTimeout(timeout);
      node.removeEventListener("mouseup", up);
      node.removeEventListener("touchend", up);
      node.removeEventListener("mousemove", cancel);
      node.removeEventListener("touchcancel", cancel);
    };

    if (touchevent) {
      node.removeEventListener("mousedown", downMouse);
      node.addEventListener("touchcancel", cancel);
      node.addEventListener("touchend", up);
    } else {
      node.addEventListener("mousemove", cancel);
      node.addEventListener("mouseup", up);
    }
  };

  const downTouch = () => down(true);
  const downMouse = () => down(false);
  node.addEventListener("mousedown", downMouse);
  node.addEventListener("touchstart", downTouch);

  return {
    destroy() {
      node.removeEventListener("mousedown", downMouse);
      node.removeEventListener("touchstart", downTouch);
    }
  };
}
